import { runDemo } from "../shared/demoRunner";
import { createFacetsScene } from "./scene";

runDemo({ createScene: createFacetsScene });
